const Logo = (props) => <img alt="Logo" src="/static/logo-branca.png" {...props} />;

export default Logo;
